import { parseSheetPriceInputToNumber } from '../../../services/materialCommerceSheetService.ts';
import type { CatalogPickOption } from '../../Perfil/PerfilMain/MisMaterialesComercio/commerceMaterialsCatalogPick.ts';
import { coerceRawUnitToMaterialSelectValue } from '../../../utils/marketplace/materialUnitSelectOptions.ts';

export type ManualAddMaterialFieldKey = 'category' | 'name' | 'unit' | 'price' | 'discount';

export type ManualAddMaterialFieldErrors = Partial<Record<ManualAddMaterialFieldKey, string>>;

export function collectManualAddMaterialClientFieldErrors(
  modRawName: string,
  modCategoryId: string,
  modUnit: string,
  catalogMaterialPick: CatalogPickOption | null,
  modUnquoted: boolean,
  modPrice: string
): ManualAddMaterialFieldErrors {
  const errs: ManualAddMaterialFieldErrors = {};
  if (!modRawName.trim()) {
    errs.name = 'Escribí el nombre del material.';
  }
  if (!catalogMaterialPick) {
    const cidPre = Number(modCategoryId);
    if (!Number.isFinite(cidPre) || cidPre <= 0) {
      errs.category = 'Elegí una categoría.';
    }
    if (!coerceRawUnitToMaterialSelectValue(modUnit)) {
      errs.unit = 'Elegí una unidad del listado.';
    }
  }
  if (!modUnquoted) {
    const raw = modPrice.trim();
    if (!raw) {
      errs.price = 'Ingresá el precio de lista para mostrarlo al público.';
    } else if (parseSheetPriceInputToNumber(raw) == null) {
      errs.price = 'Revisá el formato del precio.';
    }
  }
  return errs;
}

export function isManualAddFormClientValid(
  modRawName: string,
  modCategoryId: string,
  modUnit: string,
  catalogMaterialPick: CatalogPickOption | null,
  modUnquoted: boolean,
  modPrice: string
): boolean {
  return (
    Object.keys(
      collectManualAddMaterialClientFieldErrors(
        modRawName,
        modCategoryId,
        modUnit,
        catalogMaterialPick,
        modUnquoted,
        modPrice
      )
    ).length === 0
  );
}

export function mergeManualAddMaterialClientFieldErrorsIntoState(
  prev: ManualAddMaterialFieldErrors,
  modRawName: string,
  modCategoryId: string,
  modUnit: string,
  catalogMaterialPick: CatalogPickOption | null,
  modUnquoted: boolean,
  modPrice: string
): ManualAddMaterialFieldErrors {
  const fresh = collectManualAddMaterialClientFieldErrors(
    modRawName,
    modCategoryId,
    modUnit,
    catalogMaterialPick,
    modUnquoted,
    modPrice
  );
  const next = { ...prev };
  (['name', 'category', 'unit', 'price'] as const).forEach((k) => {
    if (fresh[k]) next[k] = fresh[k];
    else delete next[k];
  });
  return next;
}
